import React, { useEffect, useState } from 'react';
import { Grid, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';



const AdUsSaleRepView = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        totsaleqty: '',
        totbqty: '',
        totstkqty: '',
        totprate: '',
        totsrate: '',
        totamt: ''
    });

    const baseUrl = process.env.REACT_APP_BASE_URL;
    // console.log(typeof Id);
    useEffect(() => {
        const splitVal = Id?.split(',');
        // console.log(splitVal)
        const formdata = {
            itemId: splitVal[0],
            schlId: splitVal[1],
            adsid: splitVal[2]
        };
        fetchReportData(formdata);
    }, []);

    const fetchReportData = async (formData) => {
        try {
            const response = await axios.post(`${baseUrl}?apicall=getAdminUserSaleWiseItems`, formData);

            console.log('Full Response:', response);

            const tdata = response?.data?.data;

            console.log('typeof response.data.data:', typeof tdata); // should be 'object'
            console.log('Data:', tdata);

            if (Array.isArray(tdata)) {
                setTableData(tdata);

                const totstkqty = tdata.reduce((acc, sum) => acc + parseFloat(sum.qty || 0), 0);
                const totsrate = tdata.reduce((acc, sum) => acc + parseFloat(sum.disrate || 0), 0);
                const totamt = tdata.reduce((acc, sum) => acc + parseFloat(sum.disamt || 0), 0);

                setFormData(prev => ({
                    ...prev,
                    totstkqty: totstkqty,
                    totamt: totamt,
                    totsrate: totsrate
                }));
            } else {
                console.warn('tdata is not an array:', tdata);
            }

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    // console.log(tableData)

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2>User Sale Report View</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            <table>
                                <thead>
                                    <th>Sr.No.</th>
                                    <th>School</th>
                                    <th>Student</th>
                                    <th>Contact</th>
                                    <th>Barcode</th>
                                    <th>Item</th>
                                    <th>Size</th>
                                    <th>Qty</th>
                                    <th>Rate</th>
                                    <th>Amount</th>
                                    {/* <th>Sale By</th> */}
                                </thead>
                                <tbody>
                                    {tableData?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.schlNm} - <span style={{ color: 'blue' }}>{item.schlcd}</span></td>
                                            <td>{item.studNm}</td>
                                            <td>{item.studph}</td>
                                            <td>{item.stkBarcode}</td>
                                            <td>{item.itemNm}</td>
                                            <td>{item.size}</td>
                                            <td>{item.qty}</td>
                                            <td>{item.disrate}</td>
                                            <td>{item.disamt}</td>
                                            {/* <td style={{ width: '80px' }}>{item.userNm}</td> */}
                                        </tr>
                                    ))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>Total</td>
                                        <td>{formData.totstkqty}</td>

                                        <td></td>
                                        <td>{formData.totamt}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default AdUsSaleRepView;
